import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';

@Component({
  selector: 'app-cadastros-home',
  imports: [
    ListaFuncionalidadeComponent,
    HeaderComponent
  ],
  templateUrl: './cadastros-home.component.html',
  styleUrl: './cadastros-home.component.css',
})
export class CadastrosHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Cadastros;
    this.funcionalidadeEnum = FuncionalidadeEnum.Cadastros_Pessoas;
  }
}
